import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';

const baseQueryWithReAuth = createBaseQuery('media');

export const syllabusApiSlice = createApi({
  reducerPath: 'syllabusApiSlice',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['Syllabus', 'Export', 'Banner'],
  endpoints: (builder) => ({
    updateSyllabusEvent: builder.mutation({
      query: (payload) => ({
        url: '/update-syllabus-event',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['Syllabus']
    }),

    getSyllabusData: builder.query({
      query: (payload) => ({
        url: '/get-syllabus-data',
        method: 'POST',
        body: payload
      }),
      providesTags: ['Syllabus']
    }),
    deleteSyllabusEvent: builder.mutation({
      query: ({ EventId }) => ({
        url: '/delete-syllabus-event',
        method: 'POST',
        body: { EventId }
      }),
      invalidatesTags: ['Syllabus']
    }),
    exportAnnouncmentData: builder.mutation({
      query: (payload) => ({
        url: '/syllabus/brother-announcement/download',
        method: 'POST',
        body: payload,
        responseHandler: (response) => response.blob()
      }),
      invalidatesTags: ['Export']
    }),
    downloadSyllabusEvents: builder.mutation({
      query: () => ({
        url: '/download-syllabus-events',
        method: 'GET',
        responseHandler: (response) => response.blob()
      })
    }),
    getBannerData: builder.query({
      query: (payload) => ({
        url: '/banner-details',
        method: 'POST',
        body: payload
      }),
      providesTags: ['Banner']
    })
  })
});

export const {
  useUpdateSyllabusEventMutation,
  useGetSyllabusDataQuery,
  useDeleteSyllabusEventMutation,
  useDownloadSyllabusEventsMutation,
  useExportAnnouncmentDataMutation,
  useGetBannerDataQuery
} = syllabusApiSlice;
